import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Owners_ds_container_types_assignment_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { projectId?: number, ownerId?: number, materialId?: number }): 
  Promise<{ result: { Id?: number, CatchAll?: boolean, Description?: string, Height?: number, Length?: number, Name?: string, WeightCapacity?: number, Width?: number, DimensionUom?: { Name?: string, Short_name?: string }, WeightUom?: { Name?: string, Short_name?: string }, ShippingContainerTypeConfigurations?: { Id?: number }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/Owners/datasources/ds_container_types_assignment_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { projectId?: number, ownerId?: number, materialId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CatchAll?: boolean, Description?: string, Height?: number, Length?: number, Name?: string, WeightCapacity?: number, Width?: number, DimensionUom?: { Name?: string, Short_name?: string }, WeightUom?: { Name?: string, Short_name?: string }, ShippingContainerTypeConfigurations?: { Id?: number }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Owners/datasources/ds_container_types_assignment_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { projectId?: number, ownerId?: number, materialId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, CatchAll?: boolean, Description?: string, Height?: number, Length?: number, Name?: string, WeightCapacity?: number, Width?: number, DimensionUom?: { Name?: string, Short_name?: string }, WeightUom?: { Name?: string, Short_name?: string }, ShippingContainerTypeConfigurations?: { Id?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Owners/datasources/ds_container_types_assignment_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      projectId?: number, ownerId?: number, materialId?: number    }) {
      return false;
    }
}
